import { Outlet } from "@tanstack/react-router"
import { Pagination } from "modules/shared/components/Pagination"
import { usePagination } from "modules/shared/hooks/usePagination"
import { useSortBy } from "modules/shared/hooks/useSortBy"
import { useConversationTicketsQuery } from "modules/support/hooks/useConversationTicketsQuery"
import { SearchSchema } from "routes/_base/_auth/support/list/route"
import { SupportSortFields } from "schema"
import { z } from "zod"
import { ConversationTicketsTable } from "./ConversationTicketsTable"

const ITEMS_PER_PAGE = 30

type Props = {
  fullPath: string
  search: z.infer<typeof SearchSchema>
}

export function ConversationTickets({ fullPath, search }: Props) {
  const { page, totalPages, setPage, setCount, count } = usePagination({
    search,
    fullPath,
    total: ITEMS_PER_PAGE,
  })

  const { onSort, sortBy, fields } = useSortBy<typeof SupportSortFields>({
    search,
    fullPath,
    fields: ["createdAt"],
  })

  const { data, isPending } = useConversationTicketsQuery({
    query: {
      page,
      total: ITEMS_PER_PAGE,
      sortBy,
      filterBy: search.filterBy,
      query: search.query,
    },
    onSuccess: (data) => {
      setCount(data.pageInfo.count)
    },
  })

  return (
    <>
      <div className="flex flex-col gap-6 w-full h-full">
        <div className="flex flex-col gap-2">
          <div className="flex flex-col gap-4">
            <ConversationTicketsTable
              tickets={data}
              isPending={isPending}
              fields={fields}
              onSort={onSort}
              search={search}
            />
            <Pagination
              currentPage={page}
              totalPages={totalPages}
              onPageChange={setPage}
              count={count}
            />
          </div>
        </div>
      </div>
      <Outlet />
    </>
  )
}
